var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile "},[_c('v-container',{staticClass:"pt-0",attrs:{"fluid":""}},[_c('v-card',{staticClass:"pa-2 mb-3 card-r pb-2 shadow-1"},[_c('v-toolbar',{staticClass:"primary mb-3 card-r pl-3 text-white"},[_c('div',{staticClass:"text-xs-left f-20"},[_vm._v("My Profile")])]),_vm._v(" "),_c('personal')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28f2559e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pages/profile/Profile.vue
// module id = null
// module chunks = 